
import "./UserProfile.css";
import EditUser from "../../Components/EditUser/EditUser";
import { useAuth } from "../../Context/useAuth";

interface Props {}

const UserProfile = (props: Props) => {
  const { isLoggedIn, user, logout } = useAuth();

  return (
    <div className="container mt-5">
      <div className="card shadow-sm p-4">
        <div className="row g-4 align-items-center">
          <div className="col-md-3 text-center">
            <img
              src={user?.profile_pic_url}
              alt="Profile"
              className="img-fluid rounded-circle"
            />
          </div>
          <div className="col-md-6">
            <h3>{user?.first_name} {user?.last_name}</h3>
            <p className="mb-1"><strong>User name:</strong> {user?.username}</p>
            <p className="mb-1"><strong>Email:</strong> {user?.email}</p>
            <p className="mb-1"><strong>Location:</strong> {user?.location}</p>
            <p className="mb-0"><strong>Rider Type:</strong> {user?.rider_type}</p>
          </div>
          <div className="col-md-3 text-md-end text-center">
            <div className="d-flex justify-content-center details-button">
              <EditUser />
            </div>
          </div>
        </div>
      </div>
      <div className="card shadow-sm p-4 mt-4">
        <h4 className="mb-3">Update Password</h4>
        <form>
          <div className="mb-3">
            <label htmlFor="currentPassword" className="form-label">Current Password</label>
            <input type="password" className="form-control" id="currentPassword" />
          </div>
          <div className="mb-3">
            <label htmlFor="newPassword" className="form-label">New Password</label>
            <input type="password" className="form-control" id="newPassword" />
          </div>
          <div className="mb-3">
            <label htmlFor="confirmPassword" className="form-label">Confirm New Password</label>
            <input type="password" className="form-control" id="confirmPassword" />
          </div>
          <button type="submit" className="btn btn-primary">Update Password</button>
        </form>
      </div>
    </div>
  );
}

export default UserProfile;
